// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  --padding-start: 10px;
  --padding-end: 10px;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --margin-start: 0;
  --margin-end: 0;
  --margin-left: 0;
  --margin-right: 0;
}

.toolbarShadow {
  box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.25);
}

.toolbar-button-div {
  min-width: 64px;
  min-height: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.toolbar-button-div img {
  width: auto;
  height: 100%;
  display: block;
}

.toolbar-button-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--ion-color-primary);
  line-height: 150%;
  text-transform: none;
  font-size: 11px;
  text-align: center;
  width: 64px;
  margin: 0;
}

ion-menu-button {
  margin: 0;
}

ion-button[shape=dwin-toolbar] {
  --border-radius: 32px;
  height: 32px;
  width: 64px;
  margin: 0;
}

ion-grid {
  --ion-grid-column-padding: 0;
  padding: 0;
}

ion-col {
  width: 100%;
  display: flex;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/app/toolbar/dwin-toolbar.component.scss","webpack://./src/mixins.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AADF;;AAIA;EACE,0CAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AADJ;;AAKA;ECHI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EDEF,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AACF;;AAEA;EACE,4BAAA;EACA,UAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;AACF","sourcesContent":["@import \"src/mixins.scss\";\n\nion-toolbar {\n  --padding-start: 10px;\n  --padding-end: 10px;\n  --padding-top: 8px;\n  --padding-bottom: 8px;\n  --margin-start: 0;\n  --margin-end: 0;\n  --margin-left: 0;\n  --margin-right: 0;\n}\n\n.toolbarShadow {\n  box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.25);\n}\n\n.toolbar-button-div {\n  min-width: 64px;\n  min-height: 32px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  img {\n    width: auto;\n    height: 100%;\n    display: block;\n  }\n}\n\n.toolbar-button-label {\n  @include p2-style;\n  text-transform: none;\n  font-size: 11px;\n  text-align: center;\n  width: 64px;\n  margin: 0;\n}\n\nion-menu-button {\n  margin: 0;\n}\n\nion-button[shape=\"dwin-toolbar\"] {\n  --border-radius: 32px;\n  height: 32px;\n  width: 64px;\n  margin: 0;\n}\n\nion-grid {\n  --ion-grid-column-padding: 0;\n  padding: 0;\n}\n\nion-col {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n","@mixin h1-style {\n    font-size: 19px;\n    font-weight: bold;\n    color: var(--ion-color-primary);\n    line-height: 130%;\n}\n\n@mixin p1-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p1-berry-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n\n@mixin p1-white-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: white;\n    line-height: 150%;\n}\n\n@mixin p2-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p2-berry-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
